let o = null;
const n = /* @__PURE__ */ new Map();
let e = !1, s = null;
globalThis.storyCache = globalThis.storyCache || /* @__PURE__ */ new Map();
const c = () => o, r = (t) => {
  o = t;
}, b = (t) => (Object.entries(t).forEach(([l, a]) => {
  n.set(l, a);
}), n), p = (t) => n.has(t) ? n.get(t) : (console.error(`Component ${t} doesn't exist.`), !1), C = () => e, m = (t) => {
  e = t;
}, k = () => s, i = (t) => {
  s = t;
};
export {
  p as getComponent,
  k as getCustomFallbackComponent,
  C as getEnableFallbackComponent,
  c as getStoryblokApiInstance,
  b as setComponents,
  i as setCustomFallbackComponent,
  m as setEnableFallbackComponent,
  r as setStoryblokApiInstance
};
